
export const useLevelCalculation = () => {
  const calculateLevel = (points: number): number => {
    if (points < 0) return 1
    const level = Math.floor(points / 500) + 1
    return Math.min(level, 100) // Cap at level 100
  }

  const getPointsForLevel = (level: number): number => {
    if (level <= 1) return 0
    return (level - 1) * 500
  }

  const getPointsToNextLevel = (points: number): number => {
    const currentLevel = calculateLevel(points)
    if (currentLevel >= 100) return 0 // Max level reached
    
    const nextLevelPoints = getPointsForLevel(currentLevel + 1)
    return nextLevelPoints - points
  }

  const getCurrentLevelProgress = (points: number): number => {
    const currentLevel = calculateLevel(points)
    if (currentLevel >= 100) return 500 // Show full progress for max level
    
    const currentLevelStartPoints = getPointsForLevel(currentLevel)
    return points - currentLevelStartPoints
  }

  return {
    calculateLevel,
    getPointsForLevel,
    getPointsToNextLevel,
    getCurrentLevelProgress
  }
}
